"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const content_1 = __importDefault(require("./content"));
const menuContext_1 = require("./menuContext");
const Menu = ({ children, scrollable }) => {
    return ((0, jsx_runtime_1.jsx)(menuContext_1.MenuProvider, { scrollable: scrollable, children: (0, jsx_runtime_1.jsx)(content_1.default, { scrollable: scrollable, children: children }) }));
};
exports.default = Menu;
